import {AnyAction} from "redux";
import {SET_SCREEN} from "../actions/action";

export const SCREENS =
    {
        PRELOADER: 'PRELOADER',
        INTRO: 'INTRO',
        HOW_TO_PLAY: 'HOW_TO_PLAY',
        LEADERBOARD: 'LEADERBOARD',
        MAIN_MENU: 'MAIN_MENU',
        GAME_INTRO: 'GAME_INTRO',
        GAME: 'GAME',
        MINI_GAME: 'MINI_GAME',
        GAME_OVER: 'GAME_OVER',
        HIGH_SCORES: 'HIGH_SCORES'
    };


//  define selectors

export const getScreen = state => state.screen;


//  define the initial state

const initialState: string = SCREENS.MAIN_MENU;


/**
 * reducer: set the current screen ID
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function screen(state: string = initialState, action: AnyAction): string
{
    switch (action.type)
    {
        case SET_SCREEN:
        {
            const {payload} = action;
            const {screen} = payload;

            return screen;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/screen.ts